import { ReactComponent as SearchSvg } from '../../assets/search.svg';

import { IconWrapper } from './iconWrapper';
import { IconProps } from './model';

export const SearchIcon = (props: IconProps) => {
    return (
        <IconWrapper {...props}>
            <SearchSvg />
        </IconWrapper>
    );
};
